import type { TFunction } from 'i18next'
import type { TrackingStats } from '~/gql/scorm/scorm'
import { formatSeconds } from '~/helpers/learner/duration'

export type StatTileContent = {
  label: string
  value: string
  hint: string
}

/**
 * Les tuiles d'indicateurs tirées des compteurs du tableau de bord (#138), par
 * clé : le tableau de bord et la fiche session (#243) y choisissent les leurs,
 * avec les mêmes définitions et les mêmes « sur N » sous chaque chiffre.
 */
export function statTiles(stats: TrackingStats | undefined, t: TFunction) {
  const total = stats?.total ?? 0
  const passed = stats?.passed ?? 0
  const evaluated = passed + (stats?.failed ?? 0)
  const successRate = evaluated > 0 ? Math.round((passed / evaluated) * 100) : null
  const averageTime = stats?.averageTimeSeconds
  const timedHint = averageTime != null
    ? t('stats.dashboard.timedOn', { timed: stats?.timedCount ?? 0, total })
    : t('stats.dashboard.noTime')

  return {
    successRate: {
      label: t('stats.dashboard.successRate'),
      value: successRate != null ? `${successRate} %` : '—',
      hint: successRate != null
        ? t('stats.dashboard.successOn', { passed, evaluated })
        : t('stats.dashboard.noSuccess'),
    },
    averageScore: {
      label: t('stats.dashboard.averageScore'),
      value: stats?.averageScorePercent != null ? `${stats.averageScorePercent} %` : '—',
      hint: stats?.averageScorePercent != null
        ? t('stats.dashboard.scoredOn', { scored: stats.scoredCount, total })
        : t('stats.dashboard.noScore'),
    },
    averageTime: {
      label: t('stats.dashboard.averageTime'),
      value: formatSeconds(averageTime, t) ?? '—',
      hint: timedHint,
    },
    totalTime: {
      label: t('stats.dashboard.totalTime'),
      value: averageTime != null ? formatSeconds(stats?.totalTimeSeconds, t) ?? '—' : '—',
      hint: timedHint,
    },
  } satisfies Record<string, StatTileContent>
}
